import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const ADMIN_GENERAL_SETTINGS_TABLE_COLUMNS_SETTINGS_MAIN_ROUTE_NAME = Symbol('admin.settings.table-columns-settings');
export const ADMIN_GENERAL_SETTINGS_TABLE_COLUMNS_SETTINGS_TREE_ROUTE_NAME = Symbol('admin.settings.table-columns-settings');
export const TRANSLATION_GROUP_GENERAL_SETTINGS_TABLE_COLUMNS_SETTINGS = Symbol('general-settings.table-columns-settings');

export const TABLES_TREE_LIST_URL = 'admin/table_for_displays/list';
export const TABLES_TREE_LIST_QUERY_KEY = 'general-settings.tables-tree-list';

export const ADMIN_GENERAL_SETTINGS_TABLE_COLUMNS_SETTINGS_PERMISSIONS = {
  SHOW: new Permission(
    PermissionsList.admin.TABLE_COLUMNS_SETTINGS,
  ),
  SHOW_VERSIONS: new Permission(
    PermissionsList.admin.TABLE_COLUMNS_SETTINGS_VERSIONS,
  ),
  EDIT: new Permission(
    PermissionsList.admin.TABLE_COLUMNS_SETTINGS_EDIT,
  ),
};
